import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../components/vendorWebFolder/helperFunctions/axiosInstance";

// ✅ Async thunk to fetch cluster details
export const fetchClusterDetails = createAsyncThunk(
  "vendorCluster/fetchClusterDetails",
  async (selectedClusterId, thunkAPI) => {
    try {
      const response = await axiosInstance.get(
        `/vendorClusterBatches/getVendorClusterBatchById/${selectedClusterId}`
      );
      return response.data?.data; // Assuming your API sends { cluster: {...} }
    } catch (error) {
      return thunkAPI.rejectWithValue(
        error.response?.data?.message || "Failed to fetch cluster details"
      );
    }
  }
);

// ✅ Slice
const vendorClusterSlice = createSlice({
  name: "vendorCluster",
  initialState: {
    cluster: {},
    loading: false,
    error: null,
    selectedClusterId: null,
  },
  reducers: {
    setClusterId: (state, action) => {
      state.selectedClusterId = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchClusterDetails.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchClusterDetails.fulfilled, (state, action) => {
        state.loading = false;
        state.cluster = action.payload.cluster || action.payload; // adapt based on your API structure
      })
      .addCase(fetchClusterDetails.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { setClusterId } = vendorClusterSlice.actions;
export default vendorClusterSlice.reducer;
